export { default as ClientStorage } from './ClientStorage';
